import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatRadioModule } from '@angular/material/radio';

import { MaterialModule } from '@fry/components/material';
import { UIBadgeModule } from '@fry/ui/badge';

import { EditorEligibilityBlueprintsFormComponent } from './editor-eligibility-blueprints-form/editor-eligibility-blueprints-form.component';
import { EditorEligibilityDialogComponent } from './editor-eligibility-dialog/editor-eligibility-dialog.component';
import { EditorEligibilityDialogDeleteComponent } from './editor-eligibility-dialog-delete/editor-eligibility-dialog-delete.component';
import { EditorEligibilityOperatorChildrenTitleComponent } from './editor-eligibility-operator-children-title/editor-eligibility-operator-children-title.component';
import { EditorEligibilityOperatorComponent } from './editor-eligibility-operator/editor-eligibility-operator.component';
import { EditorEligibilityOperatorEditComponent } from './editor-eligibility-operator-edit/editor-eligibility-operator-edit.component';
import { EditorEligibilityOperatorTitleComponent } from './editor-eligibility-operator-title/editor-eligibility-operator-title.component';
import { EditorEligibilityOperatorEditStore } from './editor-eligibility-operator-edit/editor-eligibility-operator-edit.store';
import { EditorEligibilityRuleComponent } from './editor-eligibility-rule/editor-eligibility-rule.component';
import { EditorEligibilityRuleFormHasBookingItemComponent } from './editor-eligibility-rule-form/editor-eligibility-rule-form-has-booking-item.component';
import { EditorEligibilityRuleFormHasBookingOptionComponent } from './editor-eligibility-rule-form/editor-eligibility-rule-form-has-booking-option.component';
import { EditorEligibilityRuleFormHasBookingTypeComponent } from './editor-eligibility-rule-form/editor-eligibility-rule-form-has-booking-type.component';
import { EditorEligibilityRuleFormHasEventComponent } from './editor-eligibility-rule-form/editor-eligibility-rule-form-has-event.component';
import { EditorEligibilityRuleFormHasEventCountComponent } from './editor-eligibility-rule-form/editor-eligibility-rule-form-has-event-count.component';
import { EditorEligibilityRuleFormHasRelationComponent } from './editor-eligibility-rule-form/editor-eligibility-rule-form-has-relation.component';
import { EditorEligibilityRuleFormHasRoleComponent } from './editor-eligibility-rule-form/editor-eligibility-rule-form-has-role.component';
import { EditorEligibilityRuleFormHasDateUserFieldComponent } from './editor-eligibility-rule-form/editor-eligibility-rule-form-has-date-user-field.component';
import { EditorEligibilityRuleFormHasDiscreteUserFieldComponent } from './editor-eligibility-rule-form/editor-eligibility-rule-form-has-discrete-user-field.component';
import { EditorEligibilityRuleFormHasStringUserFieldComponent } from './editor-eligibility-rule-form/editor-eligibility-rule-form-has-string-user-field.component';
import { EditorEligibilityRuleFormIsRawOperatorComponent } from './editor-eligibility-rule-form/editor-eligibility-rule-form-is-raw-operator.component';
import { EditorEligibilityRuleValueHasBookingItemComponent } from './editor-eligibility-rule-value/editor-eligibility-rule-value-has-booking-item.component';
import { EditorEligibilityRuleValueHasBookingOptionComponent } from './editor-eligibility-rule-value/editor-eligibility-rule-value-has-booking-option.component';
import { EditorEligibilityRuleValueHasBookingTypeComponent } from './editor-eligibility-rule-value/editor-eligibility-rule-value-has-booking-type.component';
import { EditorEligibilityRuleValueHasEventComponent } from './editor-eligibility-rule-value/editor-eligibility-rule-value-has-event.component';
import { EditorEligibilityRuleValueHasEventCountComponent } from './editor-eligibility-rule-value/editor-eligibility-rule-value-has-event-count.component';
import { EditorEligibilityRuleValueHasRelationComponent } from './editor-eligibility-rule-value/editor-eligibility-rule-value-has-relation.component';
import { EditorEligibilityRuleValueHasRoleComponent } from './editor-eligibility-rule-value/editor-eligibility-rule-value-has-role.component';
import { EditorEligibilityRuleValueHasDateUserFieldComponent } from './editor-eligibility-rule-value/editor-eligibility-rule-value-has-date-user-field.component';
import { EditorEligibilityRuleValueHasDiscreteUserFieldComponent } from './editor-eligibility-rule-value/editor-eligibility-rule-value-has-discrete-user-field.component';
import { EditorEligibilityRuleValueHasStringUserFieldComponent } from './editor-eligibility-rule-value/editor-eligibility-rule-value-has-string-user-field.component';
import { EditorEligibilityRuleValueIsRawOperatorComponent } from './editor-eligibility-rule-value/editor-eligibility-rule-value-is-raw-operator.component';
import { EditorEligibilityTreeComponent } from './editor-eligibility-tree/editor-eligibility-tree.component';
import { EditorEligibilityTreeService } from './editor-eligibility-tree/editor-eligibility-tree.service';
import { EditorEligibilityTreeStore } from './editor-eligibility-tree/editor-eligibility-tree.store';
import { EditorDataService } from './editor-data/editor-data.service';


@NgModule({
  declarations: [
    EditorEligibilityBlueprintsFormComponent,
    EditorEligibilityDialogComponent,
    EditorEligibilityDialogDeleteComponent,
    EditorEligibilityOperatorChildrenTitleComponent,
    EditorEligibilityOperatorComponent,
    EditorEligibilityOperatorEditComponent,
    EditorEligibilityOperatorTitleComponent,
    EditorEligibilityRuleComponent,
    EditorEligibilityRuleFormHasBookingItemComponent,
    EditorEligibilityRuleFormHasBookingOptionComponent,
    EditorEligibilityRuleFormHasBookingTypeComponent,
    EditorEligibilityRuleFormHasEventComponent,
    EditorEligibilityRuleFormHasEventCountComponent,
    EditorEligibilityRuleFormHasRelationComponent,
    EditorEligibilityRuleFormHasRoleComponent,
    EditorEligibilityRuleFormHasDateUserFieldComponent,
    EditorEligibilityRuleFormHasDiscreteUserFieldComponent,
    EditorEligibilityRuleFormHasStringUserFieldComponent,
    EditorEligibilityRuleFormIsRawOperatorComponent,
    EditorEligibilityRuleValueHasBookingItemComponent,
    EditorEligibilityRuleValueHasBookingOptionComponent,
    EditorEligibilityRuleValueHasBookingTypeComponent,
    EditorEligibilityRuleValueHasEventComponent,
    EditorEligibilityRuleValueHasEventCountComponent,
    EditorEligibilityRuleValueHasRelationComponent,
    EditorEligibilityRuleValueHasRoleComponent,
    EditorEligibilityRuleValueHasDateUserFieldComponent,
    EditorEligibilityRuleValueHasDiscreteUserFieldComponent,
    EditorEligibilityRuleValueHasStringUserFieldComponent,
    EditorEligibilityRuleValueIsRawOperatorComponent,
    EditorEligibilityTreeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatMomentDateModule,
    MatRadioModule,
    MaterialModule,
    UIBadgeModule
  ],
  exports: [
    EditorEligibilityDialogComponent
  ],
  providers: [
    EditorEligibilityTreeService,
    EditorEligibilityTreeStore,
    EditorEligibilityOperatorEditStore,
    EditorDataService
  ]
})
export class EligibilityEditorModule {

}
